<template>
  <v-card flat color="transparent" data-aos="fade">
    <v-img
      max-height="500"
      :lazy-src="image.lazySrc"
      :position="position"
      :src="image.src"
    >
    </v-img>
    <h1 class="text-center">{{title}}</h1>
    <v-container>
      <slot></slot>
    </v-container>
    <testimonials :filter="title"></testimonials>
  </v-card>
</template>

<script>
import {
  VCard,
  VContainer,
  VImg,
} from 'vuetify/lib'
import Testimonials from '@/components/Testimonials'

export default {
  components: {
    Testimonials,
    VCard,
    VContainer,
    VImg,
  },
  computed: {
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '250px'
        case 'sm': return '400px'
        case 'md': return '500px'
        case 'lg': return '600px'
        case 'xl': return '800px'
      }
      return '800px'
    },
    height() {
      return this.$vuetify.breakpoint.xsOnly ? 300 : 'auto'
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly
    }
  },
  props: {
    image: Object,
    position: {
      default: 'center center',
      type: String,
    },
    title: String
  }
}
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 30px;
  font-family: 'Nanum Myeongjo', serif !important;
  font-size: 50px !important;
  color: rgba(0, 0, 0, 0.87);
}
</style>
